import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MailDataDto } from 'src/app/models/dto/mailData.dto';
import { SendMailDto } from 'src/app/models/dto/sendMail.dto';
import { Contact } from 'src/app/models/firebase/contact';
import { AuthService } from 'src/app/service/auth/auth.service';
import { MailerService } from 'src/app/service/mailer/mailer.service';
import { LandingPageService } from 'src/app/service/landing-page/landing-page.service';
import * as $ from 'jquery';
import { SpinnerService } from 'src/app/service/spinner/spinner.service';
import { environment } from 'src/environments/environment';
import { ToasterService } from 'src/app/service/toaster/toaster.service';
import { TranslateService } from '@ngx-translate/core';
import { LandingPage } from 'src/app/models/firebase/landing-page';
import { AboutUs } from 'src/app/models/firebase/about-us';
import { AboutUsService } from 'src/app/service/about-us/about-us.service';
import { RecaptchaLoaderService } from 'src/app/service/captcha/captcha.service';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit, OnDestroy {
    model: Contact = new Contact();
    modelAB: AboutUs = new AboutUs();
    landingPageData: LandingPage;
    @Input() title?: string = '';
    @Input() subtitle?: string = '';
    @Input() sharedContactForm: boolean = false;

    mapOptions: google.maps.MapOptions = {
        center: { lat: 0, lng: 0 },
        zoom: 14,
    };

    marker = {
        position: { lat: 0, lng: 0 },
    };

    captcha: string;
    captchaKey = environment.firebase.captchaKey;

    constructor(
        private mailerService: MailerService,
        private authService: AuthService,
        private aboutUsService: AboutUsService,
        private LandingPageService: LandingPageService,
        public spinnerService: SpinnerService,
        private toasterService: ToasterService,
        private translateService: TranslateService,
        private recaptchaLoaderService: RecaptchaLoaderService,
    ) {}

    async ngOnInit(): Promise<void> {
        this.landingPageData = await this.LandingPageService.getLandingPageData(this.authService.projectId);
        this.modelAB = await this.aboutUsService.getAboutUs(this.authService.projectId);
        this.loadMap();
        this.recaptchaLoaderService.loadScript();
    }
    ngOnDestroy(): void {
        this.recaptchaLoaderService.removeScript();
    }

    validateCaptcha(captchaResponse: string) {
        this.captcha = captchaResponse;
    }

    async loadMap(){
        const script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBZ47Oz8N79orffx9w_tuQp9IVnt3GTlb0';
        script.async = true;

        this.spinnerService.show();
        script.onload = () => {
        this.mapOptions.center.lat = this.landingPageData.company.location.lat;
        this.mapOptions.center.lng = this.landingPageData.company.location.lng;
        this.marker.position.lat = this.landingPageData.company.location.lat;
        this.marker.position.lng = this.landingPageData.company.location.lng;

        const mapElement = document.getElementById('map');
        if (mapElement) {
            const map = new google.maps.Map(mapElement, this.mapOptions);
            const marker = new google.maps.Marker({
            position: this.marker.position,
            map: map,
            });
        }

        this.spinnerService.hide();
        };

        script.onerror = () => {
        console.error('Error al cargar el script de Google Maps');
        this.spinnerService.hide();
        };

        document.body.appendChild(script);
    }

    async send() {
        this.spinnerService.show();
        const mailInfo = new MailDataDto();
        mailInfo.name = this.model.name;
        mailInfo.lastName = this.model.lastName;
        mailInfo.message = this.model.message;
        mailInfo.phone = this.model.phone;
        mailInfo.emailFrom = this.model.emailFrom;
        mailInfo.email = this.landingPageData.company.email;
        mailInfo.fromJson(this.model);

        const mail = {
            to: [mailInfo],
            templateId: 'landingContact',
            projectId: this.authService.projectId,
        } as SendMailDto;

        await this.mailerService.send(mail);
        this.model = new Contact();
        this.spinnerService.hide();
        this.toasterService.success(this.translateService.instant('landing.toaster_contact_success_message'), 'Success');
    }
}
